export default "__VITE_ASSET__BfhZlqTG__"